import { AppStrings } from "../../../../utils/constants/AppStrings";

/** Code prefix the backend uses for placement-only "special" collections. */
export const SPECIAL_COLLECTION_CODE_PREFIX = "special_";

export const COLLECTION_ACCEPTED_ICON_TYPES = [
  "image/png",
  "image/svg+xml",
  "image/webp",
];
export const COLLECTION_MAX_ICON_BYTES = 5 * 1024 * 1024;
export const COLLECTION_ICON_ACCEPT =
  "image/png,image/svg+xml,image/webp,.png,.svg,.webp";

export function isAcceptedCollectionIcon(file: File): boolean {
  if (COLLECTION_ACCEPTED_ICON_TYPES.includes(file.type)) return true;
  return /\.(png|svg|webp)$/i.test(file.name || "");
}

/**
 * Default-view dropdown options. Labels come from AppStrings so TCM can
 * recopy them; resolved per call, not at module load.
 * Order matches the Games tab: Full List → Popular → Grouped by provider.
 */
export function getCollectionDefaultViewOptions(): {
  value: string;
  label: string;
}[] {
  return [
    {
      value: "all",
      label: AppStrings.CASINO_CONFIG_COLLECTIONS_FULL_LIST,
    },
    {
      value: "popular",
      label: AppStrings.CASINO_CONFIG_COLLECTIONS_POPULAR,
    },
    {
      value: "provider",
      label: AppStrings.CASINO_CONFIG_COLLECTIONS_GROUPED_BY_PROVIDER,
    },
  ];
}

/**
 * Display label for a collection `kind` API enum. Unknown kinds fall back to
 * the raw value so a new backend enum still renders something.
 * Resolved per call, not at module load — TCM overwrites AppStrings at runtime.
 */
export function getCollectionKindLabel(kind: string): string {
  if (kind === "games") return AppStrings.CASINO_CONFIG_COLLECTIONS_GAMES_SUFFIX;
  if (kind === "providers") {
    return AppStrings.CASINO_CONFIG_COLLECTIONS_PROVIDERS_SUFFIX;
  }
  return kind;
}

/**
 * Special collections (e.g. `special_big_winners`) are placement-only for
 * membership: they exist so the collection can be positioned in Views, but
 * their games are computed/managed elsewhere (Big Winners is configured on
 * the Features page and its members are recomputed by the backend).
 *
 * Name and icon are editable from the Collections catalog (CASENG-1066) —
 * the same save path as regular collections. Delete and member add/remove
 * stay blocked so a Features/Views placement cannot be orphaned.
 *
 * The API payload exposes no dedicated `is_special` flag, so we detect them by
 * the `special_` code prefix.
 */
export function isSpecialCollection(code: string | null | undefined): boolean {
  return (
    typeof code === "string" &&
    code.startsWith(SPECIAL_COLLECTION_CODE_PREFIX)
  );
}
